"use strict";

import angular from "angular";

import template from "./visualization-compile.component.html";
import "./visualization-compile.component.scss";

import _ from "lodash";

class VisualizationCompileComponent {
    constructor($compile, $element, $scope) {
        this.$compile = $compile;
        this.$element = $element;
        this.$scope = $scope;
        this.loading = true;
    }

    $onInit() {
        this._componentCompile();
    }

    $onChanges(changes) {
        if (!_.isEmpty(_.get(changes, "component.previousValue") || {})) {
            this._componentCompile();
        }
    }

    _componentCompile() {
        this.loading = true;
        const elementToCompile = this.$element[0].getElementsByClassName(
            "component-compiled"
        );

        const regex = /\$\$(.*?)/g;
        let html = this.component.replace(regex, "$ctrl");

        const element = angular.element(elementToCompile);
        const compiled = this.$compile(html)(this.$scope);

        element[0].innerHTML = "";
        element.append(compiled);
        this.loading = false;
    }
}

export { VisualizationCompileComponent };

VisualizationCompileComponent.$inject = ["$compile", "$element", "$scope"];

const name = "visualizationCompileComponent";
const def = {
    bindings: {
        component: "<",
        bindings: "<",
        accountingId: "<",
        currentDate: "<",
        currentFilters: "<",
        accountingData: "<",
        onOpenShowtime: "&",
        visualizationId: "<"
    },
    controller: VisualizationCompileComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
